export default "__VITE_ASSET__TDD1MTyK__"